import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { UserListFilters } from "@modules/users/components";
import { useUsersList } from "./controller";
import { useUsersListColumns } from "./columns";

export const UsersList = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    selectedRows,
    agreementMap,
    dataToExport,
    setSelectedRows,
    refetch,
    translate
  } = useUsersList();

  const columns = useUsersListColumns(
    agreementMap,
    refetch,
    translate
  );

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
              active_agreement: "",
              is_admin: false,
              is_pdv: false,
            }}
          >
            <UserListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="users.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />
    </List>
  );
});
